import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { identityServices, Loader } from "../../common";
import { error } from "../../common/actions/alert.actions";

const onClose = () => {
  window.opener = null;
  window.open("", "_self");
  window.close();
};

const approvalPayload = {
  type: "success",
  title: "Approved Successfully",
  content: "Request Has Been Approved Successfully",
};

const RejectPayload = {
  type: "error",
  title: "Rejected Successfully",
  content: "Request Has Been Rejected Successfully",
};

const Unauthorized = {
  type: "warning",
  title: "Ticket Unauthorized",
  content: "Your are not authorized to perform this action",
};

class ApprovalTicketByEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const { profile, t, tenant } = this.props;
    const { caseRefId } = this.props;
    try {
      let apiUrlCustom = `${
        tenant && tenant.apiUrl
      }/ticketing/CaseValue/updateTicketByMail/${
        this.props.params.caseRefId
      }?status=${this?.props?.location?.pathname.split("/")[2]}`;
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        url: `${apiUrlCustom}`,
      };
      // @ts-ignore
      const response = await identityServices.identityApi.request(requestOptions);
			this.setState({	loading : false })
      if (response?.status === 200) {
        if (this.props.location.pathname.split("/")[2].includes('Approved')){
          this.popupMessage(approvalPayload)
        } else {
          this.popupMessage(RejectPayload)
        }
        
      }else if (response?.status === 209) {
        this.popupMessage({
					content :  `Status Has Already Been Updated!`,
					title :  `Ticket is already moved`,
					type : 'info',
				});
      } else {
        this.popupMessage({
					content :  `Not Able to Perform this action`,
					title :  `Something went wrong`,
					type : 'error',
				});
      }
    } catch (error) {
			if (error.response.data.name === 'Unauthorized'){
				this.popupMessage(Unauthorized);
			} else {
				this.popupMessage({
					content : error.response.data.message || error.response,
					title : `Something went Wrong Please contact your administrator`,
					type : error.response.data.status
				});
			}
    }
  }
  popupMessage(msg) {
    // @ts-ignore
    Swal.fire({
      title: `${msg.title}`,
      text: `${msg.content} Ticket Ref : ${this?.props?.params?.caseRefId}`,
      icon: `${msg.type}`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: "Close",
    }).then((result) => {
      if (result.value || result.isConfirmed) {
        let rediretUrl = this?.props?.location?.pathname.split('/')[1] === "approvals" ? "/approvals/my-approvals" : "/tickets/my-tickets"
        window.location.pathname = `${rediretUrl}`
      }
    });
  }
  render() {
    const { loading } = this.state;
    return (
      <>
        {/* {loading && <Loader />} */}
        {/* {apiFailed ?  : <Loader />} */}
      </>
    );
  }
}
export default withTranslation()(ApprovalTicketByEmail);
